import CartIcon from '../../../assets/icons/pass-types/cart.svg';

/**
 * Empty-state placeholder shown on the right panel when no pass has been
 * selected yet. Extracted from PassTypes to keep it focused.
 */
const PassEmptyState = () => (
  <div className="bg-white border border-gray-200 rounded-[8px] overflow-hidden shadow-sm font-noto flex flex-col justify-center items-center ml-auto w-[440px] h-[240px] p-[32px] box-border">
    <div className="flex justify-center mb-6">
      <img src={CartIcon} alt="Cart" />
    </div>
    <p className="text-center font-noto text-[14px] text-[#030407] w-[376px] h-[48px] flex items-center justify-center font-medium leading-[24px] mb-[20px]">
      Choose your pass to see available options and personalise your selection.
    </p>
    <button
      onClick={() => {}}
      disabled={true}
      className="font-noto w-[376px] h-[40px] rounded-[6px] px-[16px] py-0 gap-[6px] bg-[#EAECF0] text-[#030407] text-[13px] font-[650] leading-[14px] tracking-[0px] cursor-not-allowed flex items-center justify-center opacity-40 border-none"
    >
      Add to basket
    </button>
  </div>
);

export default PassEmptyState;
